import translationBr from './pt-br';
import translationEn from './en';

export const translations = {
  'pt-BR': translationBr,
  'en': translationEn,
};
